<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
    <div>
      <div class="d-flex justify-content-between">
        <h4>Material Usage</h4>
        <div>
            <DxButton
              icon="download"
              hint="Download Material Usage excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshGrid" />
          </div>
      </div>
      <br />
      <div class="overflow-auto">
        <DxDataGrid
          id="report-grid"
          ref="reportGrid"
            :data-source="materialUsageDataSource"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="false"
            @row-inserted="savedRows"
            @row-updated="updatedRows"
            @row-removed="removedRows"
            @selection-changed="onSelectionChanged"
          >
            <DxPaging :enabled="true" :page-size="5" />
            <DxSelection mode="single"/>
            <DxEditing
                :allow-updating="editable"
                :allow-adding="editable"
                :allow-deleting="editable"
                :use-icons="true"
                mode="row"/>
            <DxColumn
              type="buttons"
              width="5%"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>

            <DxColumn
              data-field="productName"
              caption="Product Name"
            />
            <DxColumn
              data-field="weightPerVol"
              caption="Weight/Volume unit"
            />
            <DxColumn
              data-field="unitSize"
              caption="Unit Size"
            />
            <DxColumn
              data-field="consumption"
              data-type="number"
              caption="Usage"
            />
        </DxDataGrid>
      </div>
    </div>
</template>

<script>
import { formMethods, formComputed,authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxSelection
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing, 
    DxSelection,
    DxButton
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    lastSubmitId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      selectedRow: [],
      materialUsageDataSource: null,
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
  },
  watch: {
    submitId: function (value) {
      this.refreshGrid()
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.materialUsageDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const url = mapApiUrl('/api/form/master/material-usage/list')
          return fetch(url + `?submitId=${this.submitId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/material-usage/add')
          return axios.post(url, qs.stringify(values)).then(response => response.data) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/material-usage/add')
          return axios.post(url, qs.stringify(values)).then(response => response.data) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/material-usage/delete')
          return fetch(url + `?id=${key}&submitId=${this.submitId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
    },
    refreshGrid() {
      this.$refs.reportGrid.instance.refresh()
    },
    onSelectionChanged(event) {
    }, 
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Material usage data for product name "${e.data.productName}" has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Material usage data for product name "${e.data.productName}" has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Material usage data has been removed.`, width: 500 }, 'success', 3000)
    }, 
  },
}
</script>